import request from '../../library/request';
import setGlobalState from '../setGlobalState';

export const getSuppliersInfo = async () => {
    const res = await request('supplier.getSuppliersInfo', 'get', '/supplier/suppliersInfo');
    setGlobalState('supplier', res.suppliersInfo);
};
